import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-recon-files',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-workday.component.html',
  styleUrl: './view-workday.component.css'
})
export class ViewWorkdayComponent {

}
